import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu';
import exit from '../../images/exit.svg';
import SideBarContent from './SideBarContent';
import SideBarProfile from './SideBarProfile';
import { withRouter } from 'react-router-dom';

import { TouchScrollable } from 'react-scrolllock';
import './sidebar.css';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBar: false
    };
  }

  handleStateChange = state => {
    this.setState({ sideBar: state.isOpen });
  };

  closeMenu = () => {
    this.setState({ sideBar: false });
  };

  render() {
    const { status, signedIn, history } = this.props;
    const styles = {
      bmBurgerButton: {
        position: 'fixed',
        width: '20px',
        height: '16px',
        top: `calc((50px - 16px) / 2${
          this.props.showMobileAppBanner ? ' + 56px' : ''
        })`,
        left: '24px'
      },
      bmBurgerBars: {
        background: 'white',
        height: '10%'
      },
      bmBurgerBarsHover: {
        background: '#a90000'
      },
      bmCrossButton: {
        height: '20px',
        width: '20px',
        right: '16px',
        top: '16px',
        background: 'none'
      },
      bmCross: {},
      bmMenuWrap: {
        position: 'fixed',
        height: '100%',
        padding: 0,
        transform: 'translate3d(-150%, 0px, 0px)'
      },
      bmMenu: {
        background: 'white',
        fontSize: '1.15em'
      },
      bmMorphShape: {
        fill: '#373a47'
      },
      bmItemList: {
        color: '#b8b7ad'
      },
      bmItem: {
        display: 'inline-block'
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)'
      }
    };
    return (
      <Menu
        burgerBarClassName="sidebar__burger-bars"
        isOpen={this.state.sideBar}
        onStateChange={state => this.handleStateChange(state)}
        burgerButtonClassName="sidebar__button"
        styles={styles}
        customCrossIcon={<img src={exit} alt="exit" />}>
        <TouchScrollable>
          <div className="sidebar__container">
            {signedIn ? (
              <div className="sidebar__profile">
                <SideBarProfile
                  profileButton
                  onClick={() => {
                    history.push('/profile');
                    this.closeMenu();
                  }}
                  {...this.props}
                />
              </div>
            ) : null}
            <div className="sidebar__content">
              <SideBarContent
                closeMenu={this.closeMenu}
                status={status}
                signedIn={signedIn}
              />
            </div>
          </div>
        </TouchScrollable>
      </Menu>
    );
  }
}

export default withRouter(SideBar);



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js